import { Component, Input } from '@angular/core';
import { Scene } from '@babylonjs/core/scene';
import { Fu } from './fu';
import { Texture } from '@babylonjs/core/Materials/Textures/texture';
import { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
import { Color3, Vector3, Vector4 } from '@babylonjs/core/Maths/math';
import { SceneLoader } from '@babylonjs/core/Loading/sceneLoader';
import { MeshBuilder } from '@babylonjs/core/Meshes/meshBuilder';
import * as earcut from 'earcut';
import '@babylonjs/core/Meshes/meshBuilder';
import '@babylonjs/loaders';

@Component({
    selector: 'app-map-three',
    templateUrl: './map-three.component.html',
    styleUrls: ['./map-three.component.scss']
})
export class MapThreeComponent {
    public canvas: HTMLCanvasElement;
    public scene: Scene;
    public pack: Fu;
    // å¨å±ç¼©æ¾æ¯ä¾
    public globalScaling = new Vector3(0.1, 0.1, 0.1);
    // æ¯å¦æ¾ç¤ºäºcamera
    public cameraShow: boolean = true;
    public eventCount: number = 0;
    @Input()
    public set option(data) {
        if (data) {
            this.data = data;
            this.init();
        }
    }
    public data;

    public constructor() {
        //
    }

    public init() {
        this.canvas = document.getElementById('renderCanvas') as HTMLCanvasElement;
        let radius = 12;
        let target = new Vector3(0, 1, 0);
        if (this.data) {
            if (this.data.scale) {
                radius = this.data.scale;
            }
            if (this.data.lookAt) {
                target = new Vector3(...this.data.lookAt);
            }
        }
        this.pack = new Fu(this.canvas, radius, target);
        this.scene = this.pack.scene;
        this.createBase();
    }

    public createBase() {
        const standMater = new StandardMaterial('standMater', this.scene);

        SceneLoader.ImportMesh('', '/assets/', `${this.data.ground}.stl`, this.scene, (newMeshes) => {
            const mesh = newMeshes[0];
            mesh.material = new StandardMaterial('env', this.scene);
            mesh.material.alpha = 0.2;
            mesh.position = new Vector3(0, 0, 0);
            mesh.scaling = this.globalScaling;
        });

        // strong
        this.data.mainBuilding.forEach(x => {
            const customMesh = this.pack.line2DXoZ('test', {path: x.data, width: 0.5, closed: true});
            customMesh.material = standMater;
            customMesh.material.alpha = 0.5;
            customMesh.scaling = this.globalScaling;
            customMesh.position.y = 0.75;
            for (let i = 1; i < x.floors - 1; i++) {
                const custom = customMesh.clone('custom' + i);
                custom.position.y = customMesh.position.y + (0.75 * i);
            }
        });

        this.data.roadData.forEach(x => {
            const rode = this.pack.line2DXoZ(x.name, {path: x.data, width: x.width, closed: true});
            rode.material = standMater;
            rode.material.alpha = 0.3;
            rode.scaling = this.globalScaling;
        });

        const materialBuilding = new StandardMaterial('texture6', this.scene);
        materialBuilding.opacityTexture = new Texture('assets/testAlpha.png', this.scene);
        materialBuilding.diffuseColor = new Color3(0, 128, 212);

        const faceUV = [
            new Vector4(0, 0, 0, 0),
            new Vector4(1, 1, 0, 0),
            new Vector4(0, 0, 0, 0),
        ];
        this.data.buildingData.forEach(x => {
            const mode = MeshBuilder.ExtrudePolygon(x.name, {shape: x.data, depth: x.depth, faceUV}, this.scene, earcut);
            mode.checkCollisions = true;
            mode.material = materialBuilding;
            mode.scaling = this.globalScaling;
            mode.position = x.position;
        });
    }

    public createAllCamera(res) {
        res.map(x => {
            this.pack.createCamera(x.name, x.threedCoordinate);
        });
    }

    public showAllCamera() {
        if (this.cameraShow) {
            this.pack.cameraLayer.removeAllFromScene();
        } else {
            this.pack.cameraLayer.addAllToScene();
        }
        this.cameraShow = !this.cameraShow;
    }

    public eventHappen(event) {
        this.eventCount += 1;
        // ç»å¶æåå¤´
        if (this.eventCount < 13) {
            const cameraName = `customCam${event.cameraId}`;
            const cameraPosition = event.cameraThreedCoordinate;
            const camera = this.pack.createCamera(cameraName, cameraPosition, true);
            // ç»æç¤ºçªå¹¶ç»çº¿ä¸æåå¤´åºåæ³è¿
            const title = event.eventHappenTime;
            const content = `${event.eventTypeName} - ${event.position}`;
            const eventName = `customEve${event.eventId}`;
            this.pack.createGUI(title, content, camera, eventName, this.eventCount);
            // æ ¹æ®äºä»¶ä¸­çæåå¤´ï¼ç»åºæåå¤´åºå
            if (event.cameraThreedModelArea) {
                const data = event.cameraThreedModelArea;
                const positions = data.position.map( x => new Vector3( Number(x[0]), 0, Number(x[1])));
                const areaName = `${event.buildingFloorName}${data.name}`;
                this.pack.drawWarning(areaName, positions, event.floorNumber, this.globalScaling);
            }
        }
    }
    public clean() {
        this.pack.warningLayer.dispose();
        this.pack.eventCameraLayer.dispose();
        this.pack.advancedTexture.dispose();
        this.eventCount = 0;
    }
    public rebuild(event?: any[]) {
        this.clean();
        this.pack.createAdvancedTexture();
        if (event.length > 0) {
            event.map( x => this.eventHappen(x));
        }
    }
}
